<template>
  <div>
    <searchPanel :searchType="searchType">
    </searchPanel>
    <div class="searchAll" @click="searchAll">
      {{ searchAllText }}
    </div>
    <pageFooter>
    </pageFooter>
  </div>
</template>

<script>
  import searchPanel from './search-panel.vue';
  import pageFooter  from './page-footer.vue';

  import { mapState, mapMutations } from 'vuex';

  export default {
    components : { searchPanel, pageFooter },

    computed : {
      ...mapState( 'virusTrip', [
        'searchType', 'searchDate', 'travelNumber', 'city'
      ] ),

      searchAllText() {
        let result;

        if ( this.searchType === 'flight' ) {
          result = '显示全部飞机行程';
        } else if ( this.searchType === 'train' ) {
          result = '显示全部火车行程';
        } else {
          result = '显示全部城市公共场所及交通行程';
        }

        return result;
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updateSearchDate', 'updateTravelNumber', 'updateCity',
        'updateFilterList', 'updateSearchType'
      ] ),

      setPageTitle( title ) {
        document.title = title;
      },

      setPageColor( color ) {
        document.body.style.backgroundColor = color;
      },

      getPageTitle() {
        let result;

        const { searchType } = this;

        if ( searchType === 'train' ) {
          result = '查询您乘坐的火车';
        } else if ( searchType === 'flight' ) {
          result = '查询您乘坐的飞机';
        } else if ( searchType === 'city' ) {
          result = '按城市查询';
        }

        return result;
      },

      searchAll() {
        if ( this.searchType === 'flight' || this.searchType === 'train' ) {
          this.updateSearchDate( '' );
          this.updateTravelNumber( '' );
        } else {
          this.updateCity( '' );
          this.updateFilterList( [ 'flight', 'train', 'other' ] );
        }

        const ptid = JSON.parse( localStorage.getItem( 'ptid' ) );

        ha( 'send', 'click', {
          eventId : 'search_all',
          bizsys  : 'bjyf',
          actId   : 'fy_transport',

          eventAttr : JSON.stringify( {
            type   : this.searchType,
            source : ptid
          } )
        } );

        this.$router.push( {
          path : '/virusTrip/searchResult',

          query : {
            searchType   : this.searchType,
            searchDate   : this.searchDate,
            travelNumber : this.travelNumber,
            city         : this.city
          }
        } );
      }
    },

    mounted() {
      if ( this.$route.query.searchType ) {
        this.updateSearchType( this.$route.query.searchType );
      }

      this.setPageTitle( this.getPageTitle() );
      this.setPageColor( '#88aabb' );
    }
  };
</script>

<style scoped lang="scss">
  @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/search/index.vue